import { IApplicationState } from '../../../../../../../types/types';
import { TFilterMatchLists } from '../types';

export const getFilterMatchLists = (
    state: IApplicationState
): TFilterMatchLists => {
    return state.filters.filterMatch.lists || {};
}
